import { Skeleton } from "@components/ui/skeleton";

import { cn } from "@utils/ui";

import { TEMPLATE_LIST_GRID_COLS } from "../constants/columns";

export const TemplateCardSkeleton = () => {
  return (
    <div className="flex items-center gap-4 rounded-lg border-b border-border px-4 py-3 last:border-b-0">
      <div className={cn("grid flex-1 items-center gap-4", TEMPLATE_LIST_GRID_COLS)}>
        <div className="space-y-2">
          <div className="flex items-center gap-2">
            <Skeleton className="h-5 w-48" />
            <Skeleton className="h-5 w-20 rounded-full" />
          </div>
          <Skeleton className="h-3 w-24" />
        </div>
        <Skeleton className="h-4 w-8" />
        <Skeleton className="h-4 w-20" />
      </div>
      <div className="size-4 shrink-0" />
    </div>
  );
};
